import {
  SET_SEARCH_QUERY,
  SET_HOME_ACTIVE_MENU,
  SET_SEATAPI_DATA,
  SET_TRIPS_ACTIVE_MENU,
} from '../actions/action-types.js';
import lodashCloneDeep from 'lodash/cloneDeep';

const initialState = {
  source: {},
  destination: {},
  doj: '',
  activeMenu: 'home',
  tripsActiveMenu: 0,
  error: null,
  seatapidata: {},
};

const searchReducer = (state = initialState, action) => {
  let newState = null;
  switch (action.type) {
    case SET_SEARCH_QUERY:
      newState = lodashCloneDeep(state);
      if (action.payload.type === 'source') {
        newState.source = action.payload.data;
      }
      if (action.payload.type === 'destination') {
        newState.destination = action.payload.data;
      }
      if (action.payload.type === 'doj') {
        newState.doj = action.payload.data;
      }
      return newState;

    case SET_HOME_ACTIVE_MENU:
      newState = lodashCloneDeep(state);
      newState.activeMenu = action.payload;
      return newState;

    case SET_SEATAPI_DATA:
      newState = lodashCloneDeep(state);
      newState.seatapidata = action.payload;
      return newState;

    case SET_TRIPS_ACTIVE_MENU:
      newState = lodashCloneDeep(state);
      newState.tripsActiveMenu = action.payload;
      return newState;

    default:
      return state;
  }
};

export default searchReducer;
